import React from 'react';
import { FiArrowRight } from "react-icons/fi";
import { Card, Button } from 'react-bootstrap';
import { NavBarHospital } from './Navbar';
import { useNavigation } from "./NavigationProvider";
import { navigationActions } from '../actions/navigationActions';
import headerImg from '../assets/images/header.png';
import './component.css';
import { useIntl } from "react-intl";

export const Header = ({ history }) => {
    const [locationState, dispatchNavigation] = useNavigation();

    
    const intl = useIntl();
    const { formatMessage } = intl;

    const redirectToLearnMore = () => {
        const path = '/chisiamo';

        history.push(path);
        navigationActions.changeNavigation(path, dispatchNavigation, intl);

    };

    return (
        <Card
            className="border-0 text-white border-card" 
            style={{ borderRadius: 0 }}
        >
            <Card.Img 
                src={headerImg}
                style={{ filter: "brightness(75%)" }}
                alt="Card image"
                height="200"
            />
            <Card.ImgOverlay 
                style={{
                    margin: 0,
                    padding: 0,
                }}
                className="d-flex flex-column"
            >
                <NavBarHospital history={history} />
                <div className="d-flex flex-column justify-content-center flex-grow-1 mx-3 mx-md-5">
                    <Card.Title style={{
                        fontSize: "1em",
                        marginBottom: '0.1rem'
                    }}>
                        <b>{intl.formatMessage({ id: locationState.title}) }</b>
                    </Card.Title>
                    {
                        locationState.text ?
                            (
                                <Card.Text style={{
                                    fontSize: "0.5em",
                                }}>
                                    {intl.formatMessage({ id:locationState.text})}
                                </Card.Text>
                            ) : null
                    }
                    {
                        locationState.route === '/' ?
                            (
                                <Button
                                    className="text-white border-0 button-header"
                                    style={{
                                        borderRadius: 0,
                                        position: "absolute",
                                        fontSize: "0.5em",
                                        right: "10%",
                                        backgroundColor: "#00215B",
                                    }}
                                    onClick={redirectToLearnMore}
                                >
                                    <b>{ formatMessage({ id: 'navbar.scopriDiPiu' }) } <FiArrowRight style={{ fontSize: '150%' }} /></b>
                                </Button>
                            ) : null
                    }
                </div>
            </Card.ImgOverlay>
        </Card>
    );
};